
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .filter('timeFormat', timeFormatFilter);

    function timeFormatFilter() {
        /*jshint maxcomplexity:false */
        return function (seconds) {

            if(seconds === null){ return ''; }

            var neg = seconds < 0;
            seconds = Math.abs(seconds);
            var days = Math.floor(seconds / (3600 * 24));
            seconds = seconds - (days * (3600 * 24));
            var hours = Math.floor(seconds / 3600);
            seconds = seconds - hours * 3600;
            var minutes = Math.floor(seconds / 60);
            seconds = seconds - minutes * 60;
            var sec =  Math.floor(seconds);

            var result = neg ? '-' : '';
            result +=  days ? days.toString() + 'd ' : '';
            if(days < 10) { result += hours ? hours.toString() + 'h ' : ''; }
            if(!days){
                result += minutes ? minutes.toString() + 'm ' : '';
				if (!result) {
					result += '<1m'; 
				}
            }

            return result;
        };
    }

})();